import {Col} from "antd";
import {SmileOutlined} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from 'react-redux';
import { logoutAsync } from "../../../app/store/reducers/auth/authReducer";



const LogoutForm = () => {
    const dispatch = useDispatch()

    useEffect(() => {
      dispatch(logoutAsync())
    },[])


  return (
    <>
        <Col
        className="d-flex justify-content-center align-items-center flex-column"
        style={{height: "50vh"}}
      >
        <SmileOutlined style={{fontSize: "60px", color: "yellowgreen"}} />
        <h1>Thank you for choosing us!</h1>
        <h3>We will wait for you again</h3>
        <Link to="/" className="primary fs-3 text-decoration-none">Main page</Link>
      </Col>
    </>
  )
}

export default LogoutForm